import React from 'react';

const VideocameraOutlined = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
    >
        <path
            d="m9.625 5.056.46-.154c.83-.276 1.244-.414 1.574-.332.29.073.54.253.7.505.183.287.183.724.183 1.598v.654c0 .874 0 1.311-.183 1.598-.16.252-.41.432-.7.505-.33.082-.745-.056-1.574-.332l-.46-.154m-6.3 1.556h4.433c.654 0 .98 0 1.23-.127.22-.112.398-.29.51-.51.127-.25.127-.576.127-1.23V5.367c0-.654 0-.98-.127-1.23a1.17 1.17 0 0 0-.51-.51c-.25-.127-.576-.127-1.23-.127H3.325c-.653 0-.98 0-1.23.127-.22.112-.398.29-.51.51-.127.25-.127.576-.127 1.23v3.266c0 .654 0 .98.128 1.23.111.22.29.398.51.51.249.127.576.127 1.229.127Z"
            stroke="#fff"
            strokeLinecap="round"
        />
    </svg>
);
export default VideocameraOutlined;
